import React from 'react';
import PropTypes from 'prop-types';
import './EmailVerified.scss';
import Heading from '../../../common/heading/Heading';
import {
	ONBOARDING_EMAIL_VERIFIED_SUCCESS,
	ONBOARDING_EMAIL_VERIFIED_TEXT,
	ONBOARDING_EMAIL_VERIFIED_TITLE,
} from '../../../../constants/Copy';
import { stateRender } from '../../../../helpers/react';
import { safeSameOriginUrl } from '../../../../helpers/url';
import { EmailVerifiedProceedButton } from './EmailVerifiedProceedButton';
import OnboardingProgress from '../../common/onboardingProgress/OnboardingProgress.container';
import { getPostLoginRedirectRoute } from '../../../../constants/Routes';

const EmailVerified = (props) => {
	const { isPending, gigyaRedirectUrl } = props;

	return stateRender({
		isPending,
		isError: false,
		onSuccess: renderContent,
		spinnerModifierClass: 'spinner--onboarding',
	});

	function renderContent() {
		return (
			<div className="onboarding-email-verified">
				<OnboardingProgress activeStep={3} />
				<Heading>
					{ONBOARDING_EMAIL_VERIFIED_SUCCESS}
					<br />
					{ONBOARDING_EMAIL_VERIFIED_TITLE}
				</Heading>
				<p className="onboarding__text" data-test="email-verified-proceed-title">
					{ONBOARDING_EMAIL_VERIFIED_TEXT}
				</p>
				<EmailVerifiedProceedButton
					proceedUrl={getPreTieringRedirectUrlOrDefault(gigyaRedirectUrl)}
					testId="email-verified-proceed-button"
				/>
			</div>
		);
	}

	function getPreTieringRedirectUrlOrDefault(gigyaRedirectUrl) {
		return safeSameOriginUrl(gigyaRedirectUrl) || getPostLoginRedirectRoute();
	}
};

EmailVerified.propTypes = {
	isPending: PropTypes.bool.isRequired,
	gigyaRedirectUrl: PropTypes.string,
};

export default EmailVerified;
